import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

export const RASTREIO_CANCER_OPCAO_LABEL: Record<RastreioCancerPerguntaOpcaoEnum, string> = {
  [RastreioCancerPerguntaOpcaoEnum.SIM]: 'Sim',
  [RastreioCancerPerguntaOpcaoEnum.NAO]: 'Não',
  [RastreioCancerPerguntaOpcaoEnum.NAO_SABE]: 'Não sabe',
  [RastreioCancerPerguntaOpcaoEnum.NAO_NAO_SABE_NAO_LEMBRA]: 'Não/Não sabe/Não lembra',
  [RastreioCancerPerguntaOpcaoEnum.NAO_NAO_SABE_NAO_LEMBRA_NAO_ESTA_NA_MENOPAUSA]:
    'Não/Não sabe/Não lembra/Não está na menopausa',
  [RastreioCancerPerguntaOpcaoEnum.NAO_INFORMADO]: 'Não informado',
  [RastreioCancerPerguntaOpcaoEnum.SIM_PAPANICOLAU]: 'Sim, papanicolau',
  [RastreioCancerPerguntaOpcaoEnum.SIM_MAMA_DIREITA]: 'Sim, mama direita',
  [RastreioCancerPerguntaOpcaoEnum.SIM_MAMA_ESQUERDA]: 'Sim, mama esquerda',
  [RastreioCancerPerguntaOpcaoEnum.DIREITA]: 'Direita',
  [RastreioCancerPerguntaOpcaoEnum.ESQUERDA]: 'Esquerda',
  [RastreioCancerPerguntaOpcaoEnum.AMBAS]: 'Ambas',
  [RastreioCancerPerguntaOpcaoEnum.ALTERADO]: 'Alterado',
  [RastreioCancerPerguntaOpcaoEnum.AUSENTE]: 'Ausente (Anomalias congênitas ou Retirado Cirurgicamente)',
  [RastreioCancerPerguntaOpcaoEnum.NORMAL]: 'Normal',
  [RastreioCancerPerguntaOpcaoEnum.PESSOA_VIVENDO_COM_HIV]: 'Pessoa vivendo com HIV',
  [RastreioCancerPerguntaOpcaoEnum.RASTREAMENTO]: 'Rastreamento',
  [RastreioCancerPerguntaOpcaoEnum.REPETICAO]: 'Repetição (Exame Alterado ASCUS/Baixo grau)',
  [RastreioCancerPerguntaOpcaoEnum.SEGUIMENTO]: 'Seguimento',
  [RastreioCancerPerguntaOpcaoEnum.OUTRAS_SITUACOES_IMUNOSSUPRESSAO]: 'Outras situações de imunossupressão',
  [RastreioCancerPerguntaOpcaoEnum.NUNCA_FEZ_PREVENTIVO_ANTERIORMENTE]: 'Nunca fez preventivo anteriormente',
  [RastreioCancerPerguntaOpcaoEnum.COLO_UTERO_NAO_VISUALIZADO]: 'Colo de útero não visualizado',
  [RastreioCancerPerguntaOpcaoEnum.NUNCA_FORAM_EXAMINADAS_ANTERIORMENTE]: 'Nunca foram examinadas anteriormente',
  [RastreioCancerPerguntaOpcaoEnum.DIAGNOSTICO]: 'Diagnóstico',
  [RastreioCancerPerguntaOpcaoEnum.POPULACAO_ALVO]: 'População-alvo',
  [RastreioCancerPerguntaOpcaoEnum.POPULACAO_RISCO_ELEVADO_HISTORIA_FAMILIAR]:
    'População de risco elevado (história familiar)',
  [RastreioCancerPerguntaOpcaoEnum.PACIENTE_JA_TRATADO_CANCER_MAMA]: 'Paciente já tratado de câncer de mama',
  [RastreioCancerPerguntaOpcaoEnum.CRISTALINA]: 'Cristalina',
  [RastreioCancerPerguntaOpcaoEnum.HEMORRAGICA]: 'Hemorrágica',
  [RastreioCancerPerguntaOpcaoEnum.AXILAR]: 'Axilar',
  [RastreioCancerPerguntaOpcaoEnum.SUPRACLAVICULAR]: 'Supraclavicular',
  [RastreioCancerPerguntaOpcaoEnum.QSL]: 'QSL',
  [RastreioCancerPerguntaOpcaoEnum.QIL]: 'QIL',
  [RastreioCancerPerguntaOpcaoEnum.QSM]: 'QSM',
  [RastreioCancerPerguntaOpcaoEnum.QIM]: 'QIM',
  [RastreioCancerPerguntaOpcaoEnum.UQ_LAT]: 'UQLat',
  [RastreioCancerPerguntaOpcaoEnum.UQ_SUP]: 'UQsup',
  [RastreioCancerPerguntaOpcaoEnum.UQ_MED]: 'UQmed',
  [RastreioCancerPerguntaOpcaoEnum.UQ_INF]: 'UQinf',
  [RastreioCancerPerguntaOpcaoEnum.RRA]: 'RRA',
  [RastreioCancerPerguntaOpcaoEnum.PA]: 'PA',
  [RastreioCancerPerguntaOpcaoEnum.MAMA_DIREITA]: 'Mama direita',
  [RastreioCancerPerguntaOpcaoEnum.MAMA_ESQUERDA]: 'Mama esquerda',
}
